import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Wand2 } from "lucide-react";
import { http, errMsg } from "../../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";

const TIERS = [["mini-break", "Mini-Break", 5], ["premium", "Premium", 9], ["ultra", "Ultra", 14], ["elite", "Elite", 19]];
const SEASONS = ["Spring", "Summer", "Autumn", "Winter"];

const Field = ({ label, children }) => (
  <label className="block"><span className="eyebrow block mb-1.5">{label}</span>{children}</label>
);
const sel = "w-full rounded-sm border border-stone-300 bg-white px-3 py-2 text-sm";

export const CreateFromRegister = ({ item, onClose }) => {
  const nav = useNavigate();
  const [f, setF] = useState({ collection: item?.list === "founders" ? "founders" : "researched", tier: item?.tier || "premium", season: item?.season || "Spring", days: 0 });
  const [busy, setBusy] = useState(false);
  if (!item) return null;
  const days = f.days || TIERS.find((t) => t[0] === f.tier)[2];
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: k === "days" ? Number(e.target.value) : e.target.value }));
  const go = async () => {
    setBusy(true);
    try {
      const { data } = await http.post(`/register/${item.id}/create`, { ...f, days });
      toast.success(`${item.destination} is being researched and web-verified`);
      nav(`/kits/${data.kit_id}`);
    } catch (e) { toast.error(errMsg(e)); setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="register-create-dialog" className="bg-[#FAF9F6] text-[#2B2A26] max-w-lg">
        <DialogHeader><DialogTitle className="font-display text-2xl">{item.destination}</DialogTitle></DialogHeader>
        <div className="text-sm text-stone-500 -mt-2 mb-2 capitalize">{item.edition} edition · {item.region} · {item.sheet} #{item.article}</div>
        <div className="grid grid-cols-2 gap-4">
          <Field label="Collection"><select data-testid="register-collection" className={sel} value={f.collection} onChange={set("collection")}>
            <option value="researched">Researched Kit</option><option value="founders">Founder's Collection</option></select></Field>
          <Field label="Tier"><select data-testid="register-tier" className={sel} value={f.tier} onChange={(e) => setF((s) => ({ ...s, tier: e.target.value, days: 0 }))}>
            {TIERS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select></Field>
          <Field label="Season"><select data-testid="register-season" className={sel} value={f.season} onChange={set("season")}>
            {SEASONS.map((s) => <option key={s}>{s}</option>)}</select></Field>
          <Field label="Days"><input data-testid="register-days" type="number" min={2} max={30} className={sel} value={days} onChange={set("days")} /></Field>
        </div>
        <p className="text-xs text-stone-500 mt-1">Every venue is checked with a live web search. Anything that can't be verified is replaced with a verified alternative before the kit reaches you.</p>
        <button data-testid="register-create-submit" onClick={go} disabled={busy} className="mt-2 inline-flex items-center justify-center gap-2 rounded-sm bg-[#2B2A26] text-white px-5 py-3 text-sm font-bold disabled:opacity-50">
          {busy ? <Loader2 size={15} className="animate-spin" /> : <Wand2 size={15} />} Create kit
        </button>
      </DialogContent>
    </Dialog>
  );
};
